






import { Vue, Component, Prop } from "@/shared/vuepack";
import SharedPartnerUserAdd from "@/shared/components/partners/PartnerUserAdd.vue";

@Component ({
  components: {
    SharedPartnerUserAdd
  }
})
export default class PartnerUserAdd extends Vue {
  @Prop() partnerId: number;

  @Prop() routeToPartnerUserList: (partnerId: number) => Location;
}
